/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';

/**
 * @description
 *
 *   VsVip collection
 *
 * @author Ram Pal
 */
export class VsVipCollection extends Collection {
    constructor(args = {}) {
        const allDataSources = {
            list: {
                source: 'ListCollDataSource',
                transformer: 'VsVipInventoryDataTransformer',
                transport: 'ListDataTransport',
                fields: ['config'],
            },
        };

        const extendedArgs = {
            allDataSources,
            objectName: 'vsvip-inventory',
            searchFields: ['name', 'addr'],
            windowElement: 'lazy-load',
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getAjsDependency_('VsVip');
    }
}

VsVipCollection.ajsDependencies = [
    'VsVip',
];
